import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { Reveal } from "./Reveal";
import { AREAS, waLink } from "@/data/content";

const EASE = [0.76, 0, 0.24, 1];

export const SeoAreas = () => {
  return (
    <section id="areas" data-testid="areas-section" className="overflow-hidden bg-[#111111] py-20 sm:py-28">
      {/* Outline marquee */}
      <div className="mb-14 select-none">
        <Marquee speed={35} gradient={false}>
          {[...Array(3)].map((_, k) => (
            <span
              key={k}
              className="text-stroke mx-8 font-display text-6xl font-bold uppercase tracking-tight sm:text-8xl"
            >
              Guincho 24 Horas em São Paulo <span className="text-stroke-red">·</span>{" "}
            </span>
          ))}
        </Marquee>
      </div>

      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mb-12 max-w-3xl">
          <Reveal>
            <span className="font-mono-t text-xs uppercase tracking-[0.25em] text-[#FF4444]">
              / 03 — Áreas de Atendimento
            </span>
            <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-6xl">
              Cobertura em toda a Zona Leste
            </h2>
            <p className="mt-5 text-base text-zinc-400">
              A K2 Guincho 24h atende com agilidade os principais bairros e
              avenidas da Zona Leste de São Paulo. Onde quer que você esteja,
              chegamos rápido com o guincho ideal para o seu veículo.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
          {AREAS.map((a, i) => (
            <motion.article
              key={a.name}
              data-testid={`area-card-${i}`}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, margin: "-20px" }}
              transition={{ duration: 0.4, delay: (i % 3) * 0.05, ease: EASE }}
              className="group bg-[#111111] p-6 transition-colors duration-300 hover:bg-[#1A1A1A]"
            >
              <div className="flex items-center gap-2">
                <MapPin size={15} className="text-[#D50000]" />
                <h3 className="font-display text-lg font-semibold uppercase tracking-tight text-white">
                  Guincho {a.name}
                </h3>
              </div>
              <p className="mt-2 text-sm leading-relaxed text-zinc-500 transition-colors duration-300 group-hover:text-zinc-300">
                {a.text}
              </p>
            </motion.article>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-8 max-w-2xl text-sm text-zinc-500">
            Não encontrou o seu bairro? Não tem problema — atendemos toda a região
            metropolitana.{" "}
            <a
              data-testid="areas-cta-link"
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-[#D50000] underline-offset-4 hover:underline"
            >
              Fale conosco pelo WhatsApp
            </a>{" "}
            e confirme o atendimento na sua localização.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
